import React from 'react'

export const SmallListItem = ({text, style}) => {
    return (
        <li className={  style ? style : "color-rock"}>{text}</li>
    )
}
